/**
 * Move a following figcaption into its figure.
 * Loaded from sections/main-page.liquid and sections/main-article.liquid.
 */

if (!customElements.get('page-content')) {
  customElements.define(
    'page-content',
    class PageContent extends HTMLElement {
      constructor() {
        super()
        this.querySelectorAll('figure').forEach((figure) => {
          let sibling = figure.nextElementSibling
          while (sibling) {
            if (sibling.tagName?.toLowerCase() === 'figure') break
            const figcaption =
              sibling.tagName?.toLowerCase() === 'figcaption'
                ? sibling
                : sibling.querySelector?.('figcaption')
            if (figcaption) {
              figure.appendChild(figcaption)
              if (sibling.tagName?.toLowerCase() !== 'figcaption') sibling.remove()
              break
            }
            sibling = sibling.nextElementSibling
          }
        })
      }
    }
  )
}
